import 'init/application'
import { UniversalLinks } from '../universal_links/universal_links'
import { SendToPhone } from '../universal_links/components/send_to_phone'
import '../universal_links/styles'

const universalLinksElement = document.querySelector('.js-ul-fallback')
if (universalLinksElement) {
  new UniversalLinks(universalLinksElement)
}

const sendToPhoneElement = document.querySelector('.js-send-to-phone')
if (sendToPhoneElement) {
  new SendToPhone(sendToPhoneElement)
}
